import { render } from "./TariffsPage.vue?vue&type=template&id=32b640b6&scoped=true"
import script from "./TariffsPage.vue?vue&type=script&lang=js"
export * from "./TariffsPage.vue?vue&type=script&lang=js"

import "./TariffsPage.vue?vue&type=style&index=0&id=32b640b6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b640b6"]])

export default __exports__